import QRCode from "react-qr-code";

type Props = {
  eventId: string;
  userId: string;
};
export function JoinedEventQrCode({ eventId, userId }: Props) {
  return <QRCode value={`${eventId}|${userId}`} />;
}
